import React, { useContext, useState } from "react"
import { ProductContext } from "../../../stores/session"
import ReactModal from "react-modal"
import session from "../../../stores/session"
import hasPermission from "../../../helpers/permissions"
import { useHistory, useLocation } from 'react-router-dom'

export default function PurchaseButton({ loading, purchasable, data, _cur, selectedWholesaler, purchaseCustomer, purchasableText }) {
    const { permissionPrefix, purchaseTypePrefix, uuidColumn } = useContext(ProductContext)
    const [modalIsOpen, setModalIsOpen] = useState(false)
    const [modalStep, setModalStep] = useState(1)
    const [otherName, setOtherName] = useState('')
    const isDisabled = !hasPermission(permissionPrefix, 'PURCHASE') || !purchasable || loading || !data[uuidColumn]
    const inOrOut = permissionPrefix === "VACANT_COT" ? 'in' : 'out'

    const history = useHistory()
    const location = useLocation()

    const handlePurchaseButtonClicked = async (type) => {
        await purchaseCustomer(type, otherName)
        resetModal()
    }

    const resetModal = () => {
        setModalIsOpen(false);
        setModalStep(1);
        setOtherName('')
    }

    return [
        <button
            className={`buy-button${(isDisabled) ? ' disabled' : ''}`}
            disabled={isDisabled}
            onClick={() => setModalIsOpen(true)}
        >
            {
                data.Date_Bought && data.Purchase_Type?.toLowerCase() === `${purchaseTypePrefix}_account_purchase` ?
                    `Moved ${inOrOut} on ${data.Date_Bought}${data.Bought_By ? ` by ${data.Bought_By}` : ''}`
                    : data.Purchase_Type?.toLowerCase() === `${purchaseTypePrefix}_account_exclude` ?
                        "Excluded"
                        : purchasable ?
                            purchasableText ?? `Occupier Moved ${inOrOut === 'in' ? 'In' : 'Out'}`
                            :
                            `Unavailable for Move ${inOrOut === 'in' ? 'In' : 'Out'}`
            }
        </button>,
        <ReactModal
            className="card bulk-buy"
            isOpen={modalIsOpen}>
            {
                modalStep === 1 ?
                    <>
                        <p>You have selected to move in an occupier </p>
                        <p>Select either Cancel, IDenteq for identified name or Other for an other name </p>
                        <div className='grid grid-columns-3 grid-gap-5'>
                            <button className='button compact background-red colour-white' onClick={resetModal}>Cancel</button>
                            {permissionPrefix === "VACANT_COT" && session.company.vaca_confirmation_screen && history.location.pathname.includes(session.company.vaca_confirmation_screen.replaceAll('_', '-') + '/') ?
                                <button
                                    className='button compact background-primary colour-white'
                                    onClick={() => {
                                        history.push({
                                            pathname: `/portal/vacant-cot-alerts/confirmation/`,
                                            state: { spid: data[uuidColumn], index: _cur, wholesaler: selectedWholesaler, prevPath: location.pathname }
                                        })
                                    }}
                                >
                                    Identeq
                                </button>
                                :
                                <button className='button compact background-primary colour-white' disabled={loading} onClick={() => handlePurchaseButtonClicked('IDenteq')}>
                                    {
                                        loading ?
                                            <i className="fa fa-spinner fa-spin" />
                                            :
                                            "IDenteq"
                                    }
                                </button>
                            }
                            <button className='button compact background-primary colour-white' onClick={() => setModalStep(2)}>Other</button>
                        </div>
                    </>
                    : modalStep === 2 &&
                    <>
                        <p>Please confirm your choice</p>
                        <div style={{ display: 'grid', gridTemplateColumns: 'min-content auto', marginBottom: '1em', gap: '1em  ' }}>
                            <label style={{ whiteSpace: 'nowrap' }}>Other Name: </label>
                            <input type="text" className="data-row-field" value={otherName ?? ''} onChange={(event) => setOtherName(event.target.value)} />
                        </div>
                        <div className='grid grid-columns-2 grid-gap-5'>
                            <button className='button compact background-red colour-white' disabled={loading} onClick={resetModal}>Cancel</button>
                            <button className='button compact background-primary colour-white' disabled={loading} onClick={() => handlePurchaseButtonClicked('Other')}>
                                {
                                    loading ?
                                        <i className="fa fa-spinner fa-spin" />
                                        :
                                        'Confirm'
                                }
                            </button>
                        </div>
                    </>
            }
        </ReactModal>
    ]
}